const LINE = {
  position: 'absolute',
  background: 'rgba(255,255,255,.45)',
  pointerEvents: 'none',
} as const;
const CORNER = {
  position: 'absolute',
  width: 14,
  height: 14,
  borderColor: '#fff',
  borderStyle: 'solid',
  borderWidth: 0,
  pointerEvents: 'none',
} as const;
const THIRDS = [1, 2];

/** Rule-of-thirds lines, corner marks and the 16:9 tag drawn over the crop box. */
export function CropGuides() {
  return (
    <>
      {THIRDS.map((i) => (
        <i
          key={`v${i}`}
          style={{ ...LINE, top: 0, bottom: 0, width: 1, left: `${(i * 100) / 3}%` }}
        />
      ))}
      {THIRDS.map((i) => (
        <i
          key={`h${i}`}
          style={{ ...LINE, left: 0, right: 0, height: 1, top: `${(i * 100) / 3}%` }}
        />
      ))}
      <i
        style={{
          ...CORNER,
          top: 6,
          left: 6,
          borderTopWidth: 2.5,
          borderLeftWidth: 2.5,
          borderTopLeftRadius: 4,
        }}
      />
      <i
        style={{
          ...CORNER,
          top: 6,
          right: 6,
          borderTopWidth: 2.5,
          borderRightWidth: 2.5,
          borderTopRightRadius: 4,
        }}
      />
      <i
        style={{
          ...CORNER,
          bottom: 6,
          left: 6,
          borderBottomWidth: 2.5,
          borderLeftWidth: 2.5,
          borderBottomLeftRadius: 4,
        }}
      />
      <i
        style={{
          ...CORNER,
          bottom: 6,
          right: 6,
          borderBottomWidth: 2.5,
          borderRightWidth: 2.5,
          borderBottomRightRadius: 4,
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: 7,
          right: 26,
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: '.05em',
          padding: '2px 6px',
          borderRadius: 4,
          background: 'rgba(15,25,18,.6)',
          color: '#fff',
          pointerEvents: 'none',
        }}
      >
        16:9
      </span>
    </>
  );
}
